// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NkTIF","footer":"styles_footer__3TSl1"};